<template>
  <header>
    <div class="flex items-center justify-between w-full">
      <img
        alt="singularIT Logo"
        class="w-[200px] mx-20 my-5"
        src="../assets/singularIT_logo_lang.png"
      >
      <h1 class="h-fit text-xl font-semibold text-gray-700 pr-30 grow">
        {{ t('common.header.title') }}
      </h1>
    </div>
  </header>
  <hr class="border-0 border-t-[3px] border-[#ef7d27]">
</template>

<script lang="ts" setup>
import {useI18n} from 'vue-i18n'
const {t} = useI18n()
</script>

<style scoped>

</style>
